var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"item-text":_vm.itemText,"item-value":_vm.itemValue,"value":_vm.value,"items":_vm.items,"clearable":"","label":_vm.label},on:{"input":_vm.onInput,"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }